var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var PlusSmall = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.884 11.0022C17.4363 11.0022 17.884 11.4499 17.884 12.0022C17.884 12.5545 17.4363 13.0022 16.884 13.0022L13 13.0022V16.8861C13 17.4384 12.5523 17.8861 12 17.8861C11.4477 17.8861 11 17.4384 11 16.8861V13.0022L7.11606 13.0022C6.56378 13.0022 6.11606 12.5545 6.11606 12.0022C6.11606 11.4499 6.56378 11.0022 7.11606 11.0022L11 11.0022L11 7.11821C11 6.56592 11.4477 6.11821 12 6.11821C12.5523 6.11821 13 6.56592 13 7.11821L13 11.0022L16.884 11.0022Z", fill: "currentColor" }) })));
};
